import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../../types/navigation';
import { ms, s, vs } from '../../../../utils/responsive';

// Temporary mock data - will come from backend later
const MOCK_SUCCESSORS = [
  {
    id: '1',
    name: 'Eleanor Pena',
    email: 'eleanor@gmail.com',
    image: require('../../../../assets/avatars/avatar1.png'),
  },
  {
    id: '2',
    name: 'Courtney Henry',
    email: 'courtney@gmail.com',
    image: require('../../../../assets/avatars/avatar2.png'),
  },
];

const MOCK_KEY_HOLDERS = [
  {
    id: '3',
    name: 'Leslie Alexander',
    email: 'leslie@gmail.com',
    image: require('../../../../assets/avatars/avatar3.png'),
  },
  {
    id: '4',
    name: 'Arlene McCoy',
    email: 'arlebmccoy@gmail.com',
    image: require('../../../../assets/avatars/avatar4.png'),
  },
  {
    id: '5',
    name: 'Dianne Russell',
    email: 'dianne@gmail.com',
    image: require('../../../../assets/avatars/avatar5.png'),
  },
];

type Contact = {
  id: string;
  name: string;
  email: string;
  image: any;
};

export const MortgageProviderUnlockedScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();
  const [selectedContacts, setSelectedContacts] = useState<string[]>([]);

  const toggleContact = (contactId: string) => {
    setSelectedContacts(prev =>
      prev.includes(contactId)
        ? prev.filter(id => id !== contactId)
        : [...prev, contactId]
    );
  };

  const renderContact = (contact: Contact) => {
    const isSelected = selectedContacts.includes(contact.id);

    return (
      <TouchableOpacity
        key={contact.id}
        style={styles.contactRow}
        onPress={() => toggleContact(contact.id)}
      >
        <Image source={contact.image} style={styles.contactImage} />
        <View style={styles.contactInfo}>
          <Text style={styles.contactName}>{contact.name}</Text>
          <Text style={styles.contactEmail}>{contact.email}</Text>
        </View>
        <View style={[styles.checkbox, isSelected && styles.checkboxSelected]}>
          {isSelected && (
            <Image
              source={require('../../../../assets/icons/check.png')}
              style={styles.checkIcon}
            />
          )}
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Image
            source={require('../../../../assets/icons/back.png')}
            style={styles.backIcon}
          />
        </TouchableOpacity>
        <Image
          source={require('../../../../assets/logo.png')}
          style={styles.logo}
          resizeMode="contain"
        />
      </View>

      <View style={styles.content}>
        <View style={styles.unlockIconContainer}>
          <Image
            source={require('../../../../assets/icons/BlueUnlock.png')}
            style={styles.unlockIcon}
            resizeMode="contain"
          />
          <Text style={styles.unlockText}>UNLOCKED</Text>
          <Text style={styles.subtitle}>Select who can view this data</Text>
        </View>

        <ScrollView style={styles.scrollView}>
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Successor</Text>
            {MOCK_SUCCESSORS.map(renderContact)}
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Key Holder</Text>
            {MOCK_KEY_HOLDERS.map(renderContact)}
          </View>
        </ScrollView>

        <TouchableOpacity
          style={styles.saveButton}
          onPress={() => {
            // Will handle saving selections to backend later
            navigation.navigate('FinanceChecklist');
          }}
        >
          <Text style={styles.saveButtonText}>Save Changes</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F6F8',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(15),
    paddingTop: ms(15),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: ms(15),
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: s(32),
    height: s(32),
    tintColor: '#333',
  },
  logo: {
    width: s(80),
    height: s(80),
  },
  content: {
    flex: 1,
    paddingHorizontal: ms(20),
  },
  unlockIconContainer: {
    alignItems: 'center',
    marginVertical: ms(20),
  },
  unlockIcon: {
    width: s(100),
    height: s(100),
  },
  unlockText: {
    fontSize: ms(24, 0.3),
    fontWeight: 'bold',
    color: '#1C2C4F',
    marginTop: ms(10),
  },
  subtitle: {
    fontSize: ms(18, 0.3),
    color: '#1C2C4F',
    marginTop: ms(5),
  },
  scrollView: {
    flex: 1,
    marginTop: ms(20),
  },
  section: {
    marginBottom: ms(30),
  },
  sectionTitle: {
    fontSize: ms(20, 0.3),
    fontWeight: '600',
    color: '#1C2C4F',
    marginBottom: ms(15),
  },
  contactRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: ms(10),
    marginBottom: ms(10),
  },
  contactImage: {
    width: s(50),
    height: s(50),
    borderRadius: ms(25),
  },
  contactInfo: {
    flex: 1,
    marginLeft: ms(15),
  },
  contactName: {
    fontSize: ms(16, 0.3),
    fontWeight: '600',
    color: '#1C2C4F',
  },
  contactEmail: {
    fontSize: ms(14, 0.3),
    color: '#666',
    marginTop: ms(2),
  },
  checkbox: {
    width: s(24),
    height: s(24),
    borderRadius: ms(12),
    borderWidth: 2,
    borderColor: '#1C2C4F',
    marginLeft: ms(15),
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkboxSelected: {
    backgroundColor: '#1C2C4F',
  },
  checkIcon: {
    width: s(14),
    height: s(14),
    tintColor: '#FFF',
  },
  saveButton: {
    backgroundColor: '#29BFC0',
    padding: ms(15),
    borderRadius: ms(25),
    alignItems: 'center',
    marginVertical: ms(20),
    marginBottom: ms(30),
  },
  saveButtonText: {
    color: '#FFF',
    fontSize: ms(18, 0.3),
    fontWeight: '600',
  },
});
